import './HomePane.css'

import { useContext, useState } from 'react'
import PostContext from '../contexts/PostContext'
import { useEffect } from 'react'
import ActivityCard from '../profile/ActivityCard'
import CreatePost from '../CreatePost/CreatePost'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faX , faFilter} from '@fortawesome/free-solid-svg-icons'

import ParticipantList from './ParticipantList'
import CommentsList from './CommentsList'
import GeneralContext from '../contexts/GeneralContext'

import loading_icon from '../../assets/loading_icon.gif'

const API_endpoint = 'https://webdev.cse.buffalo.edu/hci/api/api/deekstra/'

const attrGetPublicPosts =
   'posts?attributes=%7B%0A%20%20%22path%22%3A%20%22public%22%2C%0A%20%20%22equals%22%3A%20true%0A%7D&sort=newest'

/*  Function:   getAllPublicPosts
    Purpose:    Gets the list of all public posts
    Returns:    Array containing all public posts
*/
async function getAllPublicPosts() {
   const response = await fetch(`${API_endpoint}${attrGetPublicPosts}`, {
      method: 'GET',
      headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
   })
   // console.log(response);
   const responseObj = await response.json()
   // console.log(`User ID: ${sessionStorage.getItem("user")}`);
   // console.log(responseObj[1], responseObj[0]);
   if (responseObj[1]) return responseObj[0]
   else return null
}

async function getAllPrivatePosts() {
   const response = await fetch('https://webdev.cse.buffalo.edu/hci/api/api/deekstra/' + 'posts?attributes=%7B%0A%20%20%22path%22%3A%20%22public%22%2C%0A%20%20%22equals%22%3A%20false%0A%7D&sort=newest', {
      method: 'GET',
      headers: {
         'Accept': '*/*',
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
   })
   // console.log(response);
   const responseObj = await response.json()
   // console.log(`User ID: ${sessionStorage.getItem("user")}`);
   // console.log(responseObj[1], responseObj[0]);
   if (responseObj[1]) return responseObj[0]
   else return null
}

async function getLocationPosts(location){
   const response = await fetch(
      'https://webdev.cse.buffalo.edu/hci/api/api/deekstra/posts?attributes=%7B%0A%20%20%22path%22%3A%20%22location%22%2C%0A%20%20%22equals%22%3A%20%22'
      + location +'%22%2C%0A%20%20%22stringContains%22%3A%20%22' 
      + location + '%22%0A%7D&sort=newest', {
      method: 'GET',
      headers: {
         'Accept': '*/*',
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
   })
   // console.log(response);
   const responseObj = await response.json()
   // console.log(`User ID: ${sessionStorage.getItem("user")}`);
   // console.log(responseObj[1], responseObj[0]);
   if (responseObj[1]) return responseObj[0]
   else return null
}

async function getActivityPosts(activity){
   const response = await fetch(
      'https://webdev.cse.buffalo.edu/hci/api/api/deekstra/posts?attributes=%7B%0A%20%20%22path%22%3A%20%22activity%22%2C%0A%20%20%22equals%22%3A%20%22'
      + activity +'%22%2C%0A%20%20%22stringContains%22%3A%20%22' 
      + activity + '%22%0A%7D&sort=newest', {
      method: 'GET',
      headers: {
         'Accept': '*/*',
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
   })
   // console.log(response);
   const responseObj = await response.json()
   // console.log(`User ID: ${sessionStorage.getItem("user")}`);
   // console.log(responseObj[1], responseObj[0]);
   if (responseObj[1]) return responseObj[0]
   else return null
}


function getTimeNumeric() {
   let date = new Date()
   let hours = date.getHours()
   let minutes = date.getMinutes()
   let time = hours * 60 + minutes
   return time
}

function convertTimeNumeric(p) {
   // console.log(p);
   const time = p

   const timeIndex = time.indexOf(':') // : that separates hours from minutes

   if (timeIndex === -1) {
      // console.log(`Wrong schema format for post ${p.id} by author ${p.authorID}`);
      return null // String is in the wrong format
   }

   let hours = time.slice(0, timeIndex)
   let minutes = time.slice(timeIndex + 1, time.length)
   // console.log(`endTime: ${hours}:${minutes}`);

   let sum = parseInt(hours) * 60 + parseInt(minutes)
   return sum
}

function compareToToday(d) {
   if (!d) return false;
   let dateParts = d.split('/');
   let today = new Date();
   let day = today.getDate();
   let month = today.getMonth() + 1;
   let year = today.getFullYear();

   // console.log("\nDATE PARTS");
   // console.log(dateParts);
   // console.log(month, day, year);

   // If the years are not the same
   if (parseInt(dateParts[2] !== parseInt(year))) {
      if (parseInt(dateParts[2]) > parseInt(year)) return 'later'
      return 'earlier'
   } 
   // If the months are not the same
   else if (parseInt(dateParts[0]) !== parseInt(month)) {
      if (parseInt(dateParts[0]) > parseInt(month)) return 'later'
      return 'earlier'
   }
   // If the days are not the same
   else if (parseInt(dateParts[1]) !== parseInt(day)) {
      if (parseInt(dateParts[1]) > parseInt(day)) return 'later'
      return 'earlier'
   } else return 'same'
}

function filterNow(posts) {
   // console.log("FILTERING NOW");
   // console.log(posts);

   const currentTime = getTimeNumeric() // Get the current time
   const nowPosts = Promise.all(
      posts.filter((p) => {
         if (!p) return false
         // console.log("CHECK:", compareToToday(p));

         const endTime = convertTimeNumeric(p.attributes.endTime) // Get the post's ending time
         const startTime = convertTimeNumeric(p.attributes.startTime)
         // console.log('Times:', currentTime, endTime, startTime);
         if (compareToToday(p.attributes.date) === 'later') // If the start date is later than now, it's not happening yet
            return false;
         else if (compareToToday(p.attributes.date) === 'earlier') {    // If the start date is earlier than now, it may be a past event or a multiday event
            if (compareToToday(p.attributes.end_date) === 'earlier')     // If the end date is also earlier than now, the event is over
               return false;
            else if (compareToToday(p.attributes.end_date) === 'later')  // The end date is later, so the event is still ongoing
               return true;
            else if (compareToToday(p.attributes.end_date) === 'same') { // The end date is the same as today, so see if it's over
               return endTime > currentTime;  // If this post's ending time is later than the current time, add it to the nowPosts array
            }
            else {
               // console.log(`Error comparing dates, a string from database is in wrong format\n date: ${p.attributes.date}, endDate: ${p.attributes.endDate}`);
               return false;
            }
         }
         else if (compareToToday(p.attributes.date) === 'same') { // The start date is the same as today, the event could be ended, ongoing or upcoming
            if (compareToToday(p.attributes.end_date) === 'earlier') return false;   // End date is earlier than today, shouldn't be happening (invalid input)

            else if (compareToToday(p.attributes.end_date) === 'later')  // End date is later than today, so just check if the start time has passed
               return currentTime >= startTime;
            else if (compareToToday(p.attributes.end_date) === 'same')   // End date is the same as today, compare both the starting and ending times with today
               return endTime > currentTime && currentTime >= startTime   // If this post's ending time is later than the current time, add it to the nowPosts array
            else {
               // console.log(`Error comparing dates, a string from database is in wrong format\n date: ${p.attributes.date}, endDate: ${p.attributes.endDate}`);
               return false
            }
         }  
         else {
            console.log(`Error comparing dates, a string from database is in wrong format\n date: ${p.attributes.date}, endDate: ${p.attributes.endDate}`);
            return false
         }
      })
   )
   //console.log(nowPosts)
   return nowPosts
}

function filterUpcoming(posts) {
   // console.log("FILTERING UPCOMING");
   // console.log(posts);
   const currentTime = getTimeNumeric() // Get the current time
   const nowPosts = Promise.all(
      posts.filter((p) => {
         if (!p) return false
         const startTime = convertTimeNumeric(p.attributes.startTime) // Get the post's ending time
         // console.log('Times:', currentTime, startTime);

         if (compareToToday(p.attributes.date) === 'later') return true
         else if (compareToToday(p.attributes.date) === 'earlier') return false
         return startTime > currentTime // If this post's ending time is later than the current time, add it to the nowPosts array
      })
   )
   return nowPosts
}

function filterRecent(posts) {
   // console.log("FILTERING RECENT");
   // console.log(posts);
   const currentTime = getTimeNumeric() // Get the current time
   const nowPosts = Promise.all(
      posts.filter((p) => {
         if (!p) return false
         const endTime = convertTimeNumeric(p.attributes.endTime) // Get the post's ending time
         // console.log('Times:', currentTime, endTime);

         if (compareToToday(p.attributes.date) === 'earlier') return true
         else if (compareToToday(p.attributes.date) === 'later') return false
         return endTime <= currentTime // If this post's ending time is later than the current time, add it to the nowPosts array
      })
   )
   return nowPosts
}

/*  Function:   filterFriends
    Purpose:    filters posts depending on connections with user
    Parameters: friends - array full of userID's ; posts - result of fetch
    Returns:    nowPosts - array containing filtered posts  
*/
function filterFriends(friends, posts) {
   const nowPosts =(
      posts.filter((p) => {
         if(!p) return false
         console.log(p.authorID)
         console.log(friends)
         if(friends.includes(p.authorID)) return true 
         else return false
      })
   )
   //console.log(nowPosts)
   return nowPosts
}

/*  Function:   toggle
    Purpose:    Toggles a boolean value
    Parameters: t - the boolean value to be toggled
    Returns:    !t - the toggled value
*/
function toggle(t) {
   return !t
}

/*  Function:   convertTime
    Purpose:    Converts a post API object's time string to a 5 char string in the format HH:MM
    Parameters: p - the post to extract the time from
    Returns:    time - the converted string HH:MM
*/
function convertTime(p) {
   let timeIndex = p.created.indexOf(':')
   let time = p.created.slice(timeIndex + 1, timeIndex + 6)
   return time
}

/*  Function:   HomePane
    Purpose:    React component to display the user's homepage
    Returns:    React component
*/
function HomePane() {
   const {get_current_friends} = useContext(GeneralContext)

   //const [friends, setFriends] = useState([])
   let friends = []

   const { showPost, setShowPost } = useContext(PostContext)

   const [showPostBox, SetPostBox] = useState(false)

   const [filter, setFilter] = useState("public")
   const [filterOption, setFilterOption] = useState("")


   const [nowActivities, SetNowActivities] = useState([])
   const [upcomingActivities, SetUpcomingActivities] = useState([])
   const [recentActivities, SetRecentActivities] = useState([])

   const { showParticipants, setShowParticipants } = useContext(GeneralContext)
   const {showComments, setShowComments} = useContext(GeneralContext)

   const [isLoadedNow, setIsLoadedNow] = useState(false)
   const [isLoadedUpcoming, setIsLoadedUpcoming] = useState(false)
   const [isLoadedPast, setIsLoadedPast] = useState(false)

   const show_post = () => {
      SetPostBox(toggle(showPostBox))
      setShowPost(toggle(showPost))
   }

   // function that builds a string to display user friendly looking time
   const fix_string = (time) => {
      var split_time = time.split(':')
      var build = ''
      var hour = 0

      if (parseInt(split_time[0]) > 12) {
         hour = parseInt(split_time[0]) - 12
         build = hour.toString() + ':' + split_time[1] + ' PM'
      } else if (parseInt(split_time[0]) == 0) {
         build = '12:' + split_time[1] + ' AM'
      } else if (parseInt(split_time[0]) == 12) {
         build = '12:' + split_time[1] + ' PM'
      } else {
         build = split_time[0] + ':' + split_time[1] + ' AM'
      }

      return build
   }

   const only_friends = async () => {
      const user = sessionStorage.getItem("user")
      if(!friends.includes(user)) friends.push(parseInt(user))
      
      const result = await get_current_friends()

      for(let i = 0; i < result.length; i++){
         if(!friends.includes(result[i].toUserID) && result[i].toUserID != user) friends.push(result[i].toUserID)
         if(!friends.includes(result[i].fromUserID) && result[i].fromUserID != user) friends.push(result[i].fromUserID)
      }

      //console.log("Friends: " + friends)
   }

   

   const get_blockedActivity = async (activityID) => {
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/posts' +
            '?attributes=%7B%0A%20%20%22path%22%3A%20%22blockedBy%22%2C%0A%20%20%22arrayContains%22%3A%20%22'
            +sessionStorage.getItem('user')
            +'%22%0A%7D&sort=newest',
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result) {
                  // returns activity and its data
                  return result[0].map(x => x["id"])
               }
            },
            (error) => {
               console.log('error: no activity found')
            }
         )
   }
   
   useEffect(() => {
      if (!showPost && showPostBox) {
         SetPostBox(toggle(showPostBox))
      }
      
      only_friends()
      // console.log("Filter: " + filter)
      // console.log("Filter Option: " + filterOption)

      const interval = setInterval(async () => {
         let unblockedpostObj = []
         if(filter == "public"){
            unblockedpostObj = await getAllPublicPosts()
         }else if(filter == "private"){
            const private_posts = await getAllPrivatePosts()
            //console.log(private_posts)
            unblockedpostObj = filterFriends(friends,private_posts)
         }else if(filter == "activity"){
            unblockedpostObj = await getActivityPosts(filterOption)
         }else if(filter == "location"){
            unblockedpostObj = await getLocationPosts(filterOption)
         }

         if(unblockedpostObj == null){unblockedpostObj = []}

         //const postObj = await getAllPublicPosts()
         const blockedPost = await get_blockedActivity()
         const postObj = unblockedpostObj.filter(item => !blockedPost.includes(item.id))
         const nowObj = await filterNow(postObj)
         const upcomingObj = await filterUpcoming(postObj)
         const recentObj = await filterRecent(postObj)

         // console.log(nowObj);
         if (postObj) {
            // console.log("Creating Now List");
            const nowList = await Promise.all(
               nowObj.map((p) => {
                  return (
                     <div className="h-activity" key={p.id}>
                        <ActivityCard
                            name={p.author.attributes.name}
                            img_link={p.author.attributes.profile_pic_src}
                            time={fix_string(p.attributes.endTime)}
                            activity={p.attributes.activity}
                            location={p.attributes.location}
                            status={p.RecipientUserID}
                            date={p.attributes.end_date}
                            start_time={fix_string(p.attributes.startTime)}
                            start_date={p.attributes.date}
                            activityID = {p.id}
                            authorID = {p.authorID}
                        />
                     </div>
                  )
               })
            )
            SetNowActivities(nowList)
            setIsLoadedNow(true)

            const upcomingList = await Promise.all(
               upcomingObj.map((p) => {
                  return (
                     <div className="h-activity" key={p.id}>
                        <ActivityCard
                            name={p.author.attributes.name}
                            img_link={p.author.attributes.profile_pic_src}
                            time={fix_string(p.attributes.endTime)}
                            activity={p.attributes.activity}
                            location={p.attributes.location}
                            status={p.RecipientUserID}
                            date={p.attributes.end_date}
                            start_time={fix_string(p.attributes.startTime)}
                            start_date={p.attributes.date}
                            activityID = {p.id}
                            authorID = {p.authorID}
                        />
                     </div>
                  )
               })
            )
            SetUpcomingActivities(upcomingList)
            setIsLoadedUpcoming(true)

            const recentList = await Promise.all(
               recentObj.map((p) => {
                  return (
                     <div className="h-activity" key={p.id}>
                        <ActivityCard
                            name={p.author.attributes.name}
                            img_link={p.author.attributes.profile_pic_src}
                            time={fix_string(p.attributes.endTime)}
                            activity={p.attributes.activity}
                            location={p.attributes.location}
                           //  status={p.RecipientUserID}
                            status = 'past'
                            date={p.attributes.end_date}
                            start_time={fix_string(p.attributes.startTime)}
                            start_date={p.attributes.date}
                            activityID = {p.id}
                            authorID = {p.authorID}
                        />
                     </div>
                  )
               })
            )
            SetRecentActivities(recentList)
            setIsLoadedPast(true)
         } else {
            // console.log("No posts");
         }
      }, 1000)
      return () => clearInterval(interval)
   })


   useEffect(() => {
      document.title = "Home";
      document.documentElement.lang = "en";
  }, []);

   return (
      <div className="home-container">
         <div className="home-bg">
         {showParticipants && <ParticipantList />}
         {showComments && <CommentsList />}
            <div className="Pane-Header">
               <h1 > Home </h1>
            </div>
            <div className="post-box-container">
               {/* <button type="submit" onClick={() => console.log(getTime())}>Get Time</button> */}
               {showPostBox && showPost && (
                  <div className="post_modal">
                     <button
                        className="post_button"
                        type="submit"
                        onClick={show_post}
                     >
                       X Close
                     </button>
                     <CreatePost />
                  </div>
               )}
               {!showPostBox && !showPost && (
                  <div className="post_modal">
                     <button
                        className="post_button"
                        type="submit"
                        onClick={show_post}
                     >
                       + Create Post
                     </button>
                  </div>
               )}
            </div>
            <div className="filter_label"><FontAwesomeIcon icon={faFilter} /> Filter By:</div>
            <div className="filter_dropdown">
               <div className="list_wrap">
                  <ul >
                  <li className="first_ul" onClick={()=>{setFilter("public");setFilterOption("")}}>Public</li>
                  </ul>
               </div>
               <div className="list_wrap">
                  <ul>
                  <li className="first_ul" onClick={()=>{setFilter("private");setFilterOption("")}}>Private</li>
                  </ul>
               </div>
               <div className="list_wrap">
                  <ul>
                  <li className="first_ul"> Activity
                     <ul className='innerUl'>
                        <li className='innerLi' onClick={() =>{setFilter("activity");setFilterOption("Studying")}}>Studying</li>
                        <li className='innerLi' onClick={() =>{setFilter("activity");setFilterOption("Hanging Out")}}>Hanging Out</li>
                        <li className='innerLi' onClick={() =>{setFilter("activity");setFilterOption("Exercising")}}>Exercising</li>
                        <li className='innerLi' onClick={() =>{setFilter("activity");setFilterOption("Club/School Event")}}>Club/School Event</li>
                        <li className='innerLi' onClick={() =>{setFilter("activity");setFilterOption("Party")}}>Party</li>
                        <li className='innerLi' onClick={() =>{setFilter("activity");setFilterOption("Eating")}}>Eating</li>
                     </ul>
                  </li>
                  </ul>
               </div>
               <div className="list_wrap">
                  <ul>
                  <li className="first_ul">Location
                     <ul >
                        <li className='innerLi locations' >North Campus
                           <ul className="locations">
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Alfiero Center")}}>Alfiero Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Alumni Arena")}}>Alumni Arena</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Baird Hall")}}>Baird Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Baird Research Park")}}>Baird Research Park</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Baker Chilled Water Plant")}}>Baker Chilled Water Plant</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Baldy Hall")}}>Baldy Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Beane Service Center")}}>Beane Service Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Bell Hall")}}>Bell Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Bissell Hall")}}>Bissell Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Bonner Hall")}}>Bonner Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Bookstore")}}>Bookstore</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Campus Mail Center")}}>Campus Mail Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Capen Hall")}}>Capen Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Center for the Arts")}}>Center for the Arts</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Center for Tomorrow")}}>Center for Tomorrow</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Child Care Center")}}>Child Care Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Commons")}}>Commons</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Computing Center")}}>Computing Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Cooke Hall")}}>Cooke Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Creekside Village")}}>Creekside Village</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Crofts Hall")}}>Crofts Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Davis Hall")}}>Davis Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Dorsheimer Laboratory/Greenhouse")}}>Dorsheimer Laboratory/Greenhouse</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Ellicot Complex")}}>Ellicot Complex</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Flickinger Court")}}>Flickinger Court</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Flint Village")}}>Flint Village</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Fronczak Hall")}}>Fronczak Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Furnas Hall")}}>Furnas Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Governors Residence Halls")}}>Governors Residence Halls</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Lehman Hall")}}>Lehman Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Clinton Hall<")}}>Clinton Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Dewey Hall")}}>Dewey Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Roosevelt Hall")}}>Roosevelt Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Greiner Hall")}}>Greiner Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("GRoW Home")}}>GRoW Home</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Hadley Village")}}>Hadley Village</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Helm Warehouse")}}>Helm Warehouse</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("HRD BUilding")}}>HRD BUilding</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Hochstetter Hall")}}>Hochstetter Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Jacobs Management Center")}}>Jacobs Management Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Jarvis Hall")}}>Jarvis Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Ketter Hall")}}>Ketter Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Knox Lecture Hall")}}>Knox Lecture Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Lockwood Library")}}>Lockwood Library</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Mathematics Building")}}>Mathematics Building</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Morris Sports Performance Center")}}>Morris Sports Performance Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Murchie Family Fieldhouse")}}>Murchie Family Fieldhouse</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Natural Sciences Complex")}}>Natural Sciences Complex</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Norton Hall")}}>Norton Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("O'Brian Hall")}}>O'Brian Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Park Hall")}}>Park Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Slee Hall")}}>Slee Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("South Lake Village")}}>South Lake Village</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Stadium")}}>Stadium</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Statler Food Commissary")}}>Statler Food Commissary</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Student Union")}}>Student Union</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Talbert Hall")}}>Talbert Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Visitor Information Booth")}}>Visitor Information Booth</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Ellicot Complex")}}>Ellicot Complex</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Fargo Quadrangle")}}>Fargo Quadrangle</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Evans Quadrangle")}}>Evans Quadrangle</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Red Jacket Quadrangle")}}>Red Jacket Quadrangle</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Richmond Quadrangle")}}>Richmond Quadrangle</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Spaulding Quadrangle")}}>Spaulding Quadrangle</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Wilkeson Quadrangle")}}>Wilkeson Quadrangle</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Academic Center")}}>Academic Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Katharine Cornell Theatre")}}>Katharine Cornell Theatre</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Albert P. Sy Lecture Hall")}}>Albert P. Sy Lecture Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("C3 Crossroads Culinary Center")}}>C3 Crossroads Culinary Center</li>
                           </ul>
                        </li>
                         <li className="innerLi locations">South Campus
                           <ul className="locations">
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Allen Hall")}}>Allen Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Beck Hall")}}>Beck Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Biomedical Education Building")}}>Biomedical Education Building</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Biomedical Research Building")}}>Biomedical Research Building</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Cary Hall")}}>Cary Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Child Care Center")}}>Child Care Center</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Clark Hall")}}>Clark Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Clement Hall")}}>Clement Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Crosby Hall")}}>Crosby Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Diefendorf Hall")}}>Diefendorf Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Farber Annex")}}>Farber Annex</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Farber Hall")}}>Farber Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Foster Hall")}}>Foster Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Goodyear Hall")}}>Goodyear Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Harriman Hall")}}>Harriman Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Hayes A")}}>Hayes A</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("NFTA University Station")}}>NFTA University Station</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Parker Hall")}}>Parker Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Pharmacy Building")}}>Pharmacy Building</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Service Building (220 Winspear)")}}>Service Building (220 Winspear)</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Service Building (250 Winspear)")}}>Service Building (250 Winspear)</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Service Garage Building")}}>Service Garage Building</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Sherman Annex")}}>Sherman Annex</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Sherman Hall")}} >Sherman Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Squire Hall")}}>Squire Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Townsend Hall")}}>Townsend Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Wende Hall")}}>Wende Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Hayes B")}}>Hayes B</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Hayes C")}}>Hayes C</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Hayes D")}}>Hayes D</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Hayes Hall")}}>Hayes Hall</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Howe Research Building")}}>Howe Research Building</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Kimball Tower")}}>Kimball Tower</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Mackay Heating Plant")}}>Mackay Heating Plant</li>
                              <li className='innerLi' onClick={() =>{setFilter("location");setFilterOption("Michael Hall")}}>Michael Hall</li>
                           </ul>
                         </li>
                     </ul>
                     </li>
                     </ul>
                  </div>
            </div>
            {/* <div className="filter_dropdown">
               <ul>
               <li><FontAwesomeIcon icon={faFilter} />Filter By:
                  <ul>
                     <li onClick={()=>{setFilter("public");setFilterOption("")}}>Public</li>
                     <li onClick={()=>{setFilter("private");setFilterOption("")}}>Private</li>
                     <li>Activity
                     <ul>
                        <li onClick={() =>{setFilter("activity");setFilterOption("Studying")}}>Studying</li>
                        <li onClick={() =>{setFilter("activity");setFilterOption("Hanging Out")}}>Hanging Out</li>
                        <li onClick={() =>{setFilter("activity");setFilterOption("Exercising")}}>Exercising</li>
                        <li onClick={() =>{setFilter("activity");setFilterOption("Club/School Event")}}>Club/School Event</li>
                        <li onClick={() =>{setFilter("activity");setFilterOption("Party")}}>Party</li>
                        <li onClick={() =>{setFilter("activity");setFilterOption("Eating")}}>Eating</li>
                     </ul>
                     </li>
                     <li>Location
                     <ul >
                        <li className="locations">North Campus
                           <ul className="locations">
                              <li onClick={() =>{setFilter("location");setFilterOption("Alfiero Center")}}>Alfiero Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Alumni Arena")}}>Alumni Arena</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Baird Hall")}}>Baird Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Baird Research Park")}}>Baird Research Park</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Baker Chilled Water Plant")}}>Baker Chilled Water Plant</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Baldy Hall")}}>Baldy Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Beane Service Center")}}>Beane Service Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Bell Hall")}}>Bell Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Bissell Hall")}}>Bissell Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Bonner Hall")}}>Bonner Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Bookstore")}}>Bookstore</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Campus Mail Center")}}>Campus Mail Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Capen Hall")}}>Capen Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Center for the Arts")}}>Center for the Arts</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Center for Tomorrow")}}>Center for Tomorrow</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Child Care Center")}}>Child Care Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Commons")}}>Commons</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Computing Center")}}>Computing Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Cooke Hall")}}>Cooke Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Creekside Village")}}>Creekside Village</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Crofts Hall")}}>Crofts Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Davis Hall")}}>Davis Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Dorsheimer Laboratory/Greenhouse")}}>Dorsheimer Laboratory/Greenhouse</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Ellicot Complex")}}>Ellicot Complex</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Flickinger Court")}}>Flickinger Court</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Flint Village")}}>Flint Village</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Fronczak Hall")}}>Fronczak Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Furnas Hall")}}>Furnas Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Governors Residence Halls")}}>Governors Residence Halls</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Lehman Hall")}}>Lehman Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Clinton Hall<")}}>Clinton Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Dewey Hall")}}>Dewey Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Roosevelt Hall")}}>Roosevelt Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Greiner Hall")}}>Greiner Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("GRoW Home")}}>GRoW Home</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Hadley Village")}}>Hadley Village</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Helm Warehouse")}}>Helm Warehouse</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("HRD BUilding")}}>HRD BUilding</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Hochstetter Hall")}}>Hochstetter Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Jacobs Management Center")}}>Jacobs Management Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Jarvis Hall")}}>Jarvis Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Ketter Hall")}}>Ketter Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Knox Lecture Hall")}}>Knox Lecture Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Lockwood Library")}}>Lockwood Library</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Mathematics Building")}}>Mathematics Building</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Morris Sports Performance Center")}}>Morris Sports Performance Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Murchie Family Fieldhouse")}}>Murchie Family Fieldhouse</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Natural Sciences Complex")}}>Natural Sciences Complex</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Norton Hall")}}>Norton Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("O'Brian Hall")}}>O'Brian Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Park Hall")}}>Park Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Slee Hall")}}>Slee Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("South Lake Village")}}>South Lake Village</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Stadium")}}>Stadium</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Statler Food Commissary")}}>Statler Food Commissary</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Student Union")}}>Student Union</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Talbert Hall")}}>Talbert Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Visitor Information Booth")}}>Visitor Information Booth</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Ellicot Complex")}}>Ellicot Complex</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Fargo Quadrangle")}}>Fargo Quadrangle</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Evans Quadrangle")}}>Evans Quadrangle</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Red Jacket Quadrangle")}}>Red Jacket Quadrangle</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Richmond Quadrangle")}}>Richmond Quadrangle</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Spaulding Quadrangle")}}>Spaulding Quadrangle</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Wilkeson Quadrangle")}}>Wilkeson Quadrangle</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Academic Center")}}>Academic Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Katharine Cornell Theatre")}}>Katharine Cornell Theatre</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Albert P. Sy Lecture Hall")}}>Albert P. Sy Lecture Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("C3 Crossroads Culinary Center")}}>C3 Crossroads Culinary Center</li>
                           </ul>
                        </li>
                         <li className="locations">South Campus
                           <ul className="locations">
                              <li onClick={() =>{setFilter("location");setFilterOption("Allen Hall")}}>Allen Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Beck Hall")}}>Beck Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Biomedical Education Building")}}>Biomedical Education Building</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Biomedical Research Building")}}>Biomedical Research Building</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Cary Hall")}}>Cary Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Child Care Center")}}>Child Care Center</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Clark Hall")}}>Clark Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Clement Hall")}}>Clement Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Crosby Hall")}}>Crosby Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Diefendorf Hall")}}>Diefendorf Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Farber Annex")}}>Farber Annex</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Farber Hall")}}>Farber Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Foster Hall")}}>Foster Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Goodyear Hall")}}>Goodyear Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Harriman Hall")}}>Harriman Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Hayes A")}}>Hayes A</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("NFTA University Station")}}>NFTA University Station</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Parker Hall")}}>Parker Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Pharmacy Building")}}>Pharmacy Building</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Service Building (220 Winspear)")}}>Service Building (220 Winspear)</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Service Building (250 Winspear)")}}>Service Building (250 Winspear)</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Service Garage Building")}}>Service Garage Building</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Sherman Annex")}}>Sherman Annex</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Sherman Hall")}} >Sherman Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Squire Hall")}}>Squire Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Townsend Hall")}}>Townsend Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Wende Hall")}}>Wende Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Hayes B")}}>Hayes B</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Hayes C")}}>Hayes C</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Hayes D")}}>Hayes D</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Hayes Hall")}}>Hayes Hall</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Howe Research Building")}}>Howe Research Building</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Kimball Tower")}}>Kimball Tower</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Mackay Heating Plant")}}>Mackay Heating Plant</li>
                              <li onClick={() =>{setFilter("location");setFilterOption("Michael Hall")}}>Michael Hall</li>
                           </ul>
                         </li>
                     </ul>
                     </li>
                  </ul>
               </li>
               </ul>
            </div> */}
            {/* <div> */}
            {/* <button type="submit" onClick={showAcceptedRequests}>Show Accepted</button> */}
            {/* <button type="button" onClick={() => restoreToPending(59)}>Restore Pending</button> */}
            {/* </div> */}
            <div className="home-activity-list">
               {/* <p className="profile_activities_header">Happening Now</p> */}
               <div className="profile_activities_header"> <h2>Happening Now</h2> </div>
               {isLoadedNow ? <div className="home-activity-arr">{nowActivities}</div> : 
                  <div className='home_loadingDiv'>
                     <img src={loading_icon} className='img' alt="" />
                  </div>
               }
               
               {/* <p className="profile_activities_header">Upcoming Activities</p> */}
               <div className="profile_activities_header"><h2>Upcoming Activities</h2></div>
               {isLoadedUpcoming ? <div className="home-activity-arr">{upcomingActivities}</div> : 
                  <div className='home_loadingDiv'>
                     <img src={loading_icon} className='img' alt="" />
                  </div>
               }
               {/* <p className="profile_activities_header">Past Activities</p> */}
               <div className="profile_activities_header"><h2>Past Activities</h2></div>
               {isLoadedPast ? <div className="home-activity-arr">{recentActivities}</div> : 
                  <div className='home_loadingDiv'>
                     <img src={loading_icon} className='img' alt="" />
                  </div>
               }
            </div>
         </div>
      </div>
   )
}
export default HomePane